import { useState } from "react";
import { fetchSessionsReportCsv } from "../api/fetchSessionsReport/fetchSessionsReportCsvApi";
import { FetchSessionsReportParams } from "../api/fetchSessionsReport/types";
import { downloadFile } from "@/utils/downloadFile";

export function useDownloadSessionsReportCsv() {
  const [loading, setLoading] = useState(false);

  const downloadCsv = async (
    params: Omit<FetchSessionsReportParams, "page" | "pageSize"> = {},
  ) => {
    setLoading(true);
    try {
      const blob = await fetchSessionsReportCsv(params);
      const date = new Date().toISOString().split("T")[0];
      downloadFile(blob, `sessions-report-${date}.csv`);
    } finally {
      setLoading(false);
    }
  };

  return { loading, downloadCsv };
}
